import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { CMSService } from 'src/app/services/cms.service'
import storeeeee from 'store'
import { AdForm } from 'src/app/services/interface/ad.model'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzMessageService } from 'ng-zorro-antd/message'
import { NzModalRef } from 'ng-zorro-antd/modal'
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload'
import {
  HttpClient,
  HttpEventType,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http'
import { ApiService } from 'src/app/services/api.service'
import { Observable, Observer } from 'rxjs'

interface options {
  id: string
  title: string
}

const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

@Component({
  selector: 'app-add-banner',
  templateUrl: './add-banner.component.html',
  styleUrls: ['./add-banner.component.scss'],
})
export class AddBannerComponent implements OnInit {
  isLoading: boolean = false
  fileListIDN: NzUploadFile[] = []
  fileListENG: NzUploadFile[] = []
  fileListCN: NzUploadFile[] = []
  deptArr: options[] = [
    {
      id: 'ONAPPS',
      title: 'ONAPPS',
    },
    {
      id: 'ONDELIVERY',
      title: 'ONDELIVERY',
    },
    {
      id: 'ONMARKET',
      title: 'ONMARKET',
    },
    {
      id: 'ONTICKET',
      title: 'ONTICKET',
    },
  ]
  sectionArr: options[] = [
    {
      id: 'Top Page',
      title: 'Top Page',
    },
    {
      id: 'Side Page',
      title: 'Side Page',
    },
    {
      id: 'Bottom Page',
      title: 'Bottom Page',
    },
    {
      id: 'Normal',
      title: 'Normal',
    },
  ]
  constructor(
    private fb: FormBuilder,
    private cmsService: CMSService,
    private apiService: ApiService,
    private notification: NzNotificationService,
    private msg: NzMessageService,
    private modal: NzModalRef,
    private http: HttpClient,
  ) {
    this.form = this.fb.group({
      title: [null, Validators.compose([Validators.required])],
      section: [null, Validators.compose([Validators.required])],
      url: [null, Validators.compose([Validators.required])],
      dept: [null, Validators.compose([Validators.required])],
      status: [null, Validators.compose([Validators.required])],
      image: [null, Validators.compose([Validators.required])],
    })
  }

  form: FormGroup

  ngOnInit(): void {
    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty()
        this.form.controls[i].updateValueAndValidity()
      }
    }
    this.form.statusChanges.subscribe(state => {
      this.modal.updateConfig({ nzOkDisabled: state === 'INVALID' })
    })
  }

  submitForm = (): void => {
    this.isLoading = true
    var isUploading = false
    this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })

    for (let i = 0; i < this.fileListIDN.length; i++) {
      if (['uploading', 'error'].includes(this.fileListIDN[i].status)) {
        isUploading = true
        break
      }
      if (isUploading) break
    }
    for (let i = 0; i < this.fileListENG.length; i++) {
      if (['uploading', 'error'].includes(this.fileListENG[i].status)) {
        isUploading = true
        break
      }
      if (isUploading) break
    }
    for (let i = 0; i < this.fileListCN.length; i++) {
      if (['uploading', 'error'].includes(this.fileListCN[i].status)) {
        isUploading = true
        break
      }
      if (isUploading) break
    }

    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty()
        this.form.controls[i].updateValueAndValidity()
      }
    }
    if (!isUploading && this.form.valid) {
      var formSubs: AdForm = this.form.value
      formSubs.image = {
        idn: {
          name: this.fileListIDN[0].response?.name || this.fileListIDN[0].name,
          status: this.fileListIDN[0].status,
          url: this.fileListIDN[0].response?.url || this.fileListIDN[0].url,
          uid: this.fileListIDN[0].uid,
        },
        eng: {
          name: this.fileListENG[0].response?.name || this.fileListENG[0].name,
          status: this.fileListENG[0].status,
          url: this.fileListENG[0].response?.url || this.fileListENG[0].url,
          uid: this.fileListENG[0].uid,
        },
        cn: {
          name: this.fileListCN[0].response?.name || this.fileListCN[0].name,
          status: this.fileListCN[0].status,
          url: this.fileListCN[0].response?.url || this.fileListCN[0].url,
          uid: this.fileListCN[0].uid,
        },
      }
      this.cmsService.createAd(formSubs).subscribe(
        r => {
          this.notification.success('Success', r.message)
          this.isLoading = false
          this.modal.destroy()
          this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
          return true
        },
        err => {
          this.notification.error('Error', err.error.message)
          this.isLoading = false
          this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
          return false
        },
      )
    } else {
      this.msg.error(
        isUploading ? 'Please wait until all files uploaded' : 'Please Fill Blank Form',
      )
      this.isLoading = false
      this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
      return
    }
  }

  handleBeforeUpload = (file: NzUploadFile): boolean => {
    if (file.size <= 11534336) {
      return true
    } else {
      this.msg.error('File too Large')
      return false
    }
  }

  customUploadReq = (item: NzUploadXHRArgs) => {
    const formData = new FormData()
    formData.append('file', item.file as any)

    const req = new HttpRequest(
      'POST',
      this.apiService.API_SUNSHINE_SERVER + '/api/upload/temp',
      formData,
      {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + storeeeee.get('accessToken'),
        }),
        reportProgress: true,
        withCredentials: false,
      },
    )

    return this.http.request(req).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          if (event.total > 0) {
            ;(event as any).percent = (event.loaded / event.total) * 100 // tslint:disable-next-line:no-any
          }
          item.onProgress!(event, item.file)
        } else if (event instanceof HttpResponse) {
          item.onSuccess!(event.body, item.file, event)
        }
      },
      err => {
        // console.log(err)
        /* error */
        item.onError!(err, item.file)
      },
    )
  }

  handleRemove = (file: NzUploadFile) =>
    new Observable((observer: Observer<boolean>) => {
      this.form.patchValue({ image: null })
      observer.next(true)
      observer.complete()
    })

  handleDownload = (file: NzUploadFile): void => {
    window.open((file.response?.url || file.url) + '?s=download', '_blank')
  }

  previewImage: string | undefined = ''
  previewVisible = false

  handlePreview = async (file: NzUploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj!)
    }
    this.previewImage = file.response?.url || file.url || file.preview
    this.previewVisible = true
  }

  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`)
      this.form.patchValue({ image: true })
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`)
    }
  }
}
